import { parsePrivateKey } from "sshpk";

export default function sshPrivateKey(input: string): string {
  try {
    parsePrivateKey(input);
    return "";
  } catch {
    return `invalid ssh private key`;
  }
}
